import muiSelectModuleCss from '../../../assets/css/mui.select.module.css';
import { Select } from "@material-ui/core";
import InputEvents from './InputEvents';
import GoogleTagManager from '../../../gtm/GoogleTagManager';
import GtmFormularfeldId, { createGtmFieldId } from '../../../gtm/types/GtmFormularfeldId';

type Param = {
    id: string,
    idGtm: GtmFormularfeldId,
    idGtmIndex?: number,
    value: unknown,
    fullWidth?: boolean,
    disabled?: boolean
    onChange: (event: React.ChangeEvent<{ value: unknown }>) => void
}

const SelectField: React.FC<Param> = ({ children, id, idGtm, idGtmIndex, value, fullWidth = false, disabled = false, onChange }) => {

    const handleOnFocus = () => {
        const gtmFieldId = createGtmFieldId(idGtm, idGtmIndex);
        GoogleTagManager.fireEventFormularfeld(gtmFieldId);
    }

    return (
        <Select classes={muiSelectModuleCss}
            id={id}
            value={value}
            disabled={disabled}
            disableUnderline
            onFocus={handleOnFocus}
            onChange={onChange}
            onKeyPress={InputEvents.preventOnKeyPressEnter}
            fullWidth={fullWidth}>
            {children}
        </Select>
    );
}

export default SelectField;